import {
  QUOTE_UPLOAD_ATTACH,
  QUOTE_UPLOAD_ATTACH_CLEAR_DATA,
  QUOTE_UPLOAD_ATTACH_ERROR,
  QUOTE_UPLOAD_ATTACH_SUCCESS,
  QUOTE_UPLOAD_DOCUMENT,
  QUOTE_UPLOAD_DOCUMENT_CLEAR_DATA,
  QUOTE_UPLOAD_DOCUMENT_ERROR,
  QUOTE_UPLOAD_DOCUMENT_SUCCESS,
} from "./actionTypes";

export const postQuoteAttach = (uploadAttachments) => {
  return {
    type: QUOTE_UPLOAD_ATTACH,
    payload: { uploadAttachments },
  };
};

export const postQuoteAttachSuccess = (success) => {
  return {
    type: QUOTE_UPLOAD_ATTACH_SUCCESS,
    payload: success,
  };
};

export const postQuoteAttachError = (error) => {
  return {
    type: QUOTE_UPLOAD_ATTACH_ERROR,
    payload: error,
  };
};

export const postQuoteAttachClearData = () => {
  return {
    type: QUOTE_UPLOAD_ATTACH_CLEAR_DATA,
    payload: {},
  };
};

export const postQuoteUploadDocument = (uploadDocuments) => {
  return {
    type: QUOTE_UPLOAD_DOCUMENT,
    payload: { uploadDocuments },
  };
};

export const postQuoteUploadDocumentSuccess = (success) => {
  return {
    type: QUOTE_UPLOAD_DOCUMENT_SUCCESS,
    payload: success,
  };
};

export const postQuoteUploadDocumentError = (error) => {
  return {
    type: QUOTE_UPLOAD_DOCUMENT_ERROR,
    payload: error,
  };
};

export const postQuoteUploadDocumentClearData = () => {
  return {
    type: QUOTE_UPLOAD_DOCUMENT_CLEAR_DATA,
    payload: {},
  };
};
